import { find, get } from "lodash";
import { useState } from "react";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import { PROCESS } from "utils/api/graphql/queries/processes";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import ExpirationModal from "../Widgets/ExpirationModal";
import View from "./View";

const CollectionNeeds = ({ project, onNext, onBack, tracer }) => {
  const [nextLoading, setNextLoading] = useState(false);
  const next = (fields) => {
    setNextLoading(true);
    onNext({
      payload: {
        fields,
      },
      onCompleted: () => setNextLoading(false),
      onError: () => setNextLoading(false),
    });
  };
  const { data } = useQuery(COVERAGE_CATEGORIES, {
    variables: { gt: { weight: 0 } },
  });

  const { data: processData, loading: processLoading } = useQuery(PROCESS, {
    variables: { where: { id: get(tracer, "flow.process.id") } },
    skip: !get(tracer, "flow.process.id"),
  });

  if (processLoading) return <Loading />;

  const needsConfig = find(
    get(processData, "process.config", []),
    ({ type }) => type === PROCESS_CONFIG_TYPES.NEEDS,
  );

  const needsLevels = get(needsConfig, "value.needsLevels") || 5;
  const labels = get(needsConfig, "value.labels", {});

  return (
    <>
      <ExpirationModal project={project} />
      <View
        data={get(data, "coverageCategories.data") || []}
        next={next}
        project={project}
        nextLoading={nextLoading}
        onBack={onBack}
        needsLevels={needsLevels}
        labels={labels}
      />
    </>
  );
};

export default CollectionNeeds;
